/**
 * @flow
 */
'use strict';

export const icdCodes = [
  {"code":"360.00","description":"360.00: Purulent endophthalmitis, unspecified"},
  {"code":"360.01","description":"360.01: Acute endophthalmitis"},
  {"code":"360.02","description":"360.02: Panophthalmitis"},
  {"code":"360.03","description":"360.03: Chronic endophthalmitis"},
  {"code":"360.04","description":"360.04: Vitreous abscess"},
  {"code":"360.11","description":"360.11: Sympathetic uveitis"},
  {"code":"360.12","description":"360.12: Panuveitis"},
  {"code":"360.13","description":"360.13: Parasitic endophthalmitis NOS"},
  {"code":"360.14","description":"360.14: Ophthalmia nodosa"},
  {"code":"360.19","description":"360.19: Other endophthalmitis"},
  {"code":"360.20","description":"360.20: Degenerative disorder of globe, unspecified"},
  {"code":"360.21","description":"360.21: Progressive high (degenerative) myopia"},
  {"code":"360.23","description":"360.23: Siderosis of globe"},
  {"code":"360.24","description":"360.24: Other metallosis of globe"},
  {"code":"360.29","description":"360.29: Other degenerative disorders of globe"},
  {"code":"360.30","description":"360.30: Hypotony of eye, unspecified"},
  {"code":"360.31","description":"360.31: Primary hypotony of eye"},
  {"code":"360.32","description":"360.32: Ocular fistula causing hypotony"},
  {"code":"360.33","description":"360.33: Hypotony associated with other ocular disorders"},
  {"code":"360.34","description":"360.34: Flat anterior chamber of eye"},
  {"code":"360.40","description":"360.40: Degenerated globe or eye, unspecified"},
  {"code":"360.41","description":"360.41: Blind hypotensive eye"},
  {"code":"360.42","description":"360.42: Blind hypertensive eye"},
  {"code":"360.43","description":"360.43: Hemophthalmos, except current injury"},
  {"code":"360.44","description":"360.44: Leucocoria"},
  {"code":"360.50","description":"360.50: Foreign body, magnetic, intraocular, unspecified"},
  {"code":"360.51","description":"360.51: Foreign body, magnetic, in anterior chamber of eye"},
  {"code":"360.52","description":"360.52: Foreign body, magnetic, in iris or ciliary body"},
  {"code":"360.53","description":"360.53: Foreign body, magnetic, in lens"},
  {"code":"360.54","description":"360.54: Foreign body, magnetic, in vitreous"},
  {"code":"360.55","description":"360.55: Foreign body, magnetic, in posterior wall"},
  {"code":"360.59","description":"360.59: Intraocular foreign body, magnetic, in other or multiple sites"},
  {"code":"360.60","description":"360.60: Foreign body, intraocular, unspecified"},
  {"code":"360.61","description":"360.61: Foreign body in anterior chamber"},
  {"code":"360.62","description":"360.62: Foreign body in iris or ciliary body"},
  {"code":"360.63","description":"360.63: Foreign body in lens"},
  {"code":"360.64","description":"360.64: Foreign body in vitreous"},
  {"code":"360.65","description":"360.65: Foreign body in posterior wall of eye"},
  {"code":"360.69","description":"360.69: Intraocular foreign body in other or multiple sites"},
  {"code":"360.81","description":"360.81: Luxation of globe"},
  {"code":"360.89","description":"360.89: Other disorders of globe"},
  {"code":"360.9","description":"360.9: Unspecified disorder of globe"},
  {"code":"361.00","description":"361.00: Retinal detachment with retinal defect, unspecified"},
  {"code":"361.01","description":"361.01: Recent retinal detachment, partial, with single defect"},
  {"code":"361.02","description":"361.02: Recent retinal detachment, partial, with multiple defects"},
  {"code":"361.03","description":"361.03: Recent retinal detachment, partial, with giant tear"},
  {"code":"361.04","description":"361.04: Recent retinal detachment, partial, with retinal dialysis"},
  {"code":"361.05","description":"361.05: Recent retinal detachment, total or subtotal"},
  {"code":"361.06","description":"361.06: Old retinal detachment, partial"},
  {"code":"361.07","description":"361.07: Old retinal detachment, total or subtotal"},
  {"code":"361.10","description":"361.10: Retinoschisis, unspecified"},
  {"code":"361.11","description":"361.11: Flat retinoschisis"},
  {"code":"361.12","description":"361.12: Bullous retinoschisis"},
  {"code":"361.13","description":"361.13: Primary retinal cysts"},
  {"code":"361.14","description":"361.14: Secondary retinal cysts"},
  {"code":"361.19","description":"361.19: Other retinoschisis and retinal cysts"},
  {"code":"361.2","description":"361.2: Serous retinal detachment"},
  {"code":"361.30","description":"361.30: Retinal defect, unspecified"},
  {"code":"361.31","description":"361.31: Round hole of retina without detachment"},
  {"code":"361.32","description":"361.32: Horseshoe tear of retina without detachment"},
  {"code":"361.33","description":"361.33: Multiple defects of retina without detachment"},
  {"code":"361.81","description":"361.81: Traction detachment of retina"},
  {"code":"361.89","description":"361.89: Other forms of retinal detachment"},
  {"code":"361.9","description":"361.9: Unspecified retinal detachment"},
  {"code":"362.01","description":"362.01: Background diabetic retinopathy"},
  {"code":"362.02","description":"362.02: Proliferative diabetic retinopathy"},
  {"code":"362.03","description":"362.03: Nonproliferative diabetic retinopathy NOS"},
  {"code":"362.04","description":"362.04: Mild nonproliferative diabetic retinopathy"},
  {"code":"362.05","description":"362.05: Moderate nonproliferative diabetic retinopathy"},
  {"code":"362.06","description":"362.06: Severe nonproliferative diabetic retinopathy"},
  {"code":"362.07","description":"362.07: Diabetic macular edema"},
  {"code":"362.10","description":"362.10: Background retinopathy, unspecified"},
  {"code":"362.11","description":"362.11: Hypertensive retinopathy"},
  {"code":"362.12","description":"362.12: Exudative retinopathy"},
  {"code":"362.13","description":"362.13: Changes in vascular appearance of retina"},
  {"code":"362.14","description":"362.14: Retinal microaneurysms NOS"},
  {"code":"362.15","description":"362.15: Retinal telangiectasia"},
  {"code":"362.16","description":"362.16: Retinal neovascularization NOS"},
  {"code":"362.17","description":"362.17: Other intraretinal microvascular abnormalities"},
  {"code":"362.18","description":"362.18: Retinal vasculitis"},
  {"code":"362.20","description":"362.20: Retinopathy of prematurity, unspecified"},
  {"code":"362.21","description":"362.21: Retrolental fibroplasia"},
  {"code":"362.22","description":"362.22: Retinopathy of prematurity, stage 0"},
  {"code":"362.23","description":"362.23: Retinopathy of prematurity, stage 1"},
  {"code":"362.24","description":"362.24: Retinopathy of prematurity, stage 2"},
  {"code":"362.25","description":"362.25: Retinopathy of prematurity, stage 3"},
  {"code":"362.26","description":"362.26: Retinopathy of prematurity, stage 4"},
  {"code":"362.27","description":"362.27: Retinopathy of prematurity, stage 5"},
  {"code":"362.29","description":"362.29: Other nondiabetic proliferative retinopathy"},
  {"code":"362.30","description":"362.30: Retinal vascular occlusion, unspecified"},
  {"code":"362.31","description":"362.31: Central retinal artery occlusion"},
  {"code":"362.32","description":"362.32: Retinal arterial branch occlusion"},
  {"code":"362.33","description":"362.33: Partial retinal arterial occlusion"},
  {"code":"362.34","description":"362.34: Transient retinal arterial occlusion"},
  {"code":"362.35","description":"362.35: Central retinal vein occlusion"},
  {"code":"362.36","description":"362.36: Venous tributary (branch) occlusion"},
  {"code":"362.37","description":"362.37: Venous engorgement"},
  {"code":"362.40","description":"362.40: Retinal layer separation, unspecified"},
  {"code":"362.41","description":"362.41: Central serous retinopathy"},
  {"code":"362.42","description":"362.42: Serous detachment of retinal pigment epithelium"},
  {"code":"362.43","description":"362.43: Hemorrhagic detachment of retinal pigment epithelium"},
  {"code":"362.50","description":"362.50: Macular degeneration (senile), unspecified"},
  {"code":"362.51","description":"362.51: Nonexudative senile macular degeneration"},
  {"code":"362.52","description":"362.52: Exudative senile macular degeneration"},
  {"code":"362.53","description":"362.53: Cystoid macular degeneration"},
  {"code":"362.54","description":"362.54: Macular cyst, hole, or pseudohole"},
  {"code":"362.55","description":"362.55: Toxic maculopathy"},
  {"code":"362.56","description":"362.56: Macular puckering"},
  {"code":"362.57","description":"362.57: Drusen (degenerative)"},
  {"code":"362.60","description":"362.60: Peripheral retinal degeneration, unspecified"},
  {"code":"362.61","description":"362.61: Paving stone degeneration"},
  {"code":"362.62","description":"362.62: Microcystoid degeneration"},
  {"code":"362.63","description":"362.63: Lattice degeneration"},
  {"code":"362.64","description":"362.64: Senile reticular degeneration"},
  {"code":"362.65","description":"362.65: Secondary pigmentary degeneration"},
  {"code":"362.66","description":"362.66: Secondary vitreoretinal degenerations"},
  {"code":"362.70","description":"362.70: Hereditary retinal dystrophy, unspecified"},
  {"code":"362.71","description":"362.71: Retinal dystrophy in systemic or cerebroretinal lipidoses"},
  {"code":"362.72","description":"362.72: Retinal dystrophy in other systemic disorders and syndromes"},
  {"code":"362.73","description":"362.73: Vitreoretinal dystrophies"},
  {"code":"362.74","description":"362.74: Pigmentary retinal dystrophy"},
  {"code":"362.75","description":"362.75: Other dystrophies primarily involving the sensory retina"},
  {"code":"362.76","description":"362.76: Dystrophies primarily involving the retinal pigment epithelium"},
  {"code":"362.77","description":"362.77: Dystrophies primarily involving Bruch\'s membrane"},
  {"code":"362.81","description":"362.81: Retinal hemorrhage"},
  {"code":"362.82","description":"362.82: Retinal exudates and deposits"},
  {"code":"362.83","description":"362.83: Retinal edema"},
  {"code":"362.84","description":"362.84: Retinal ischemia"},
  {"code":"362.85","description":"362.85: Retinal nerve fiber bundle defects"},
  {"code":"362.89","description":"362.89: Other retinal disorders"},
  {"code":"362.9","description":"362.9: Unspecified retinal disorder"},
  {"code":"363.00","description":"363.00: Focal chorioretinitis, unspecified"},
  {"code":"363.01","description":"363.01: Focal choroiditis and chorioretinitis, juxtapapillary"},
  {"code":"363.03","description":"363.03: Focal choroiditis and chorioretinitis of other posterior pole"},
  {"code":"363.04","description":"363.04: Focal choroiditis and chorioretinitis, peripheral"},
  {"code":"363.05","description":"363.05: Focal retinitis and retinochoroiditis, juxtapapillary"},
  {"code":"363.06","description":"363.06: Focal retinitis and retinochoroiditis, macular or paramacular"},
  {"code":"363.07","description":"363.07: Focal retinitis and retinochoroiditis of other posterior pole"},
  {"code":"363.08","description":"363.08: Focal retinitis and retinochoroiditis, peripheral"},
  {"code":"363.10","description":"363.10: Disseminated chorioretinitis, unspecified"},
  {"code":"363.11","description":"363.11: Disseminated choroiditis and chorioretinitis, posterior pole"},
  {"code":"363.12","description":"363.12: Disseminated choroiditis and chorioretinitis, peripheral"},
  {"code":"363.13","description":"363.13: Disseminated choroiditis and chorioretinitis, generalized"},
  {"code":"363.14","description":"363.14: Disseminated retinitis and retinochoroiditis, metastatic"},
  {"code":"363.15","description":"363.15: Disseminated retinitis and retinochoroiditis, pigment epitheliopathy"},
  {"code":"363.20","description":"363.20: Chorioretinitis, unspecified"},
  {"code":"363.21","description":"363.21: Pars planitis"},
  {"code":"363.22","description":"363.22: Harada\'s disease"},
  {"code":"363.30","description":"363.30: Chorioretinal scar, unspecified"},
  {"code":"363.31","description":"363.31: Solar retinopathy"},
  {"code":"363.32","description":"363.32: Other macular scars"},
  {"code":"363.33","description":"363.33: Other scars of posterior pole"},
  {"code":"363.34","description":"363.34: Peripheral scars"},
  {"code":"363.35","description":"363.35: Disseminated scars"},
  {"code":"363.40","description":"363.40: Choroidal degeneration, unspecified"},
  {"code":"363.41","description":"363.41: Senile atrophy of choroid"},
  {"code":"363.42","description":"363.42: Diffuse secondary atrophy of choroid"},
  {"code":"363.43","description":"363.43: Angioid streaks of choroid"},
  {"code":"363.50","description":"363.50: Hereditary choroidal dystrophy or atrophy, unspecified"},
  {"code":"363.51","description":"363.51: Circumpapillary dystrophy of choroid, partial"},
  {"code":"363.52","description":"363.52: Circumpapillary dystrophy of choroid, total"},
  {"code":"363.53","description":"363.53: Central dystrophy of choroid, partial"},
  {"code":"363.54","description":"363.54: Central choroidal atrophy, total"},
  {"code":"363.55","description":"363.55: Choroideremia"},
  {"code":"363.56","description":"363.56: Other diffuse or generalized dystrophy of choroid, partial"},
  {"code":"363.57","description":"363.57: Other diffuse or generalized dystrophy of choroid, total"},
  {"code":"363.61","description":"363.61: Choroidal hemorrhage, unspecified"},
  {"code":"363.62","description":"363.62: Expulsive choroidal hemorrhage"},
  {"code":"363.63","description":"363.63: Choroidal rupture"},
  {"code":"363.70","description":"363.70: Choroidal detachment, unspecified"},
  {"code":"363.71","description":"363.71: Serous choroidal detachment"},
  {"code":"363.72","description":"363.72: Hemorrhagic choroidal detachment"},
  {"code":"363.8","description":"363.8: Other disorders of choroid"},
  {"code":"363.9","description":"363.9: Unspecified disorder of choroid"},
  {"code":"364.00","description":"364.00: Acute and subacute iridocyclitis, unspecified"},
  {"code":"364.01","description":"364.01: Primary iridocyclitis"},
  {"code":"364.02","description":"364.02: Recurrent iridocyclitis"},
  {"code":"364.03","description":"364.03: Secondary iridocyclitis, infectious"},
  {"code":"364.04","description":"364.04: Secondary iridocyclitis, noninfectious"},
  {"code":"364.05","description":"364.05: Hypopyon"},
  {"code":"364.10","description":"364.10: Chronic iridocyclitis, unspecified"},
  {"code":"364.11","description":"364.11: Chronic iridocyclitis in diseases classified elsewhere"},
  {"code":"364.21","description":"364.21: Fuchs\' heterochromic cyclitis"},
  {"code":"364.22","description":"364.22: Glaucomatocyclitic crises"},
  {"code":"364.23","description":"364.23: Lens-induced iridocyclitis"},
  {"code":"364.24","description":"364.24: Vogt-koyanagi syndrome"},
  {"code":"364.3","description":"364.3: Unspecified iridocyclitis"},
  {"code":"364.41","description":"364.41: Hyphema of iris and ciliary body"},
  {"code":"364.42","description":"364.42: Rubeosis iridis"},
  {"code":"364.51","description":"364.51: Essential or progressive iris atrophy"},
  {"code":"364.52","description":"364.52: Iridoschisis"},
  {"code":"364.53","description":"364.53: Pigmentary iris degeneration"},
  {"code":"364.54","description":"364.54: Degeneration of pupillary margin"},
  {"code":"364.55","description":"364.55: Miotic cysts of pupillary margin"},
  {"code":"364.56","description":"364.56: Degenerative changes of chamber angle"},
  {"code":"364.57","description":"364.57: Degenerative changes of ciliary body"},
  {"code":"364.59","description":"364.59: Other iris atrophy"},
  {"code":"364.60","description":"364.60: Idiopathic cysts of iris, ciliary body, and anterior chamber"},
  {"code":"364.61","description":"364.61: Implantation cysts of iris, ciliary body, and anterior chamber"},
  {"code":"364.62","description":"364.62: Exudative cysts of iris or anterior chamber"},
  {"code":"364.63","description":"364.63: Primary cyst of pars plana"},
  {"code":"364.64","description":"364.64: Exudative cyst of pars plana"},
  {"code":"364.70","description":"364.70: Adhesions of iris, unspecified"},
  {"code":"364.71","description":"364.71: Posterior synechiae of iris"},
  {"code":"364.72","description":"364.72: Anterior synechiae of iris"},
  {"code":"364.73","description":"364.73: Goniosynechiae"},
  {"code":"364.74","description":"364.74: Adhesions and disruptions of pupillary membranes"},
  {"code":"364.75","description":"364.75: Pupillary abnormalities"},
  {"code":"364.76","description":"364.76: Iridodialysis"},
  {"code":"364.77","description":"364.77: Recession of chamber angle of eye"},
  {"code":"364.81","description":"364.81: Floppy iris syndrome"},
  {"code":"364.82","description":"364.82: Plateau iris syndrome"},
  {"code":"364.89","description":"364.89: Other disorders of iris and ciliary body"},
  {"code":"364.9","description":"364.9: Unspecified disorder of iris and ciliary body"},
  {"code":"365.00","description":"365.00: Preglaucoma, unspecified"},
  {"code":"365.01","description":"365.01: Open angle with borderline findings, low risk"},
  {"code":"365.02","description":"365.02: Anatomical narrow angle borderline glaucoma"},
  {"code":"365.03","description":"365.03: Steroid responders borderline glaucoma"},
  {"code":"365.04","description":"365.04: Ocular hypertension"},
  {"code":"365.05","description":"365.05: Open angle with borderline findings, high risk"},
  {"code":"365.06","description":"365.06: Primary angle closure without glaucoma damage"},
  {"code":"365.10","description":"365.10: Open-angle glaucoma, unspecified"},
  {"code":"365.11","description":"365.11: Primary open angle glaucoma"},
  {"code":"365.12","description":"365.12: Low tension open-angle glaucoma"},
  {"code":"365.13","description":"365.13: Pigmentary open-angle glaucoma"},
  {"code":"365.14","description":"365.14: Glaucoma of childhood"},
  {"code":"365.15","description":"365.15: Residual stage of open angle glaucoma"},
  {"code":"365.20","description":"365.20: Primary angle-closure glaucoma, unspecified"},
  {"code":"365.21","description":"365.21: Intermittent angle-closure glaucoma"},
  {"code":"365.22","description":"365.22: Acute angle-closure glaucoma"},
  {"code":"365.23","description":"365.23: Chronic angle-closure glaucoma"},
  {"code":"365.24","description":"365.24: Residual stage of angle-closure glaucoma"},
  {"code":"365.31","description":"365.31: Corticosteroid-induced glaucoma, glaucomatous stage"},
  {"code":"365.32","description":"365.32: Corticosteroid-induced glaucoma, residual stage"},
  {"code":"365.41","description":"365.41: Glaucoma associated with chamber angle anomalies"},
  {"code":"365.42","description":"365.42: Glaucoma associated with anomalies of iris"},
  {"code":"365.43","description":"365.43: Glaucoma associated with other anterior segment anomalies"},
  {"code":"365.44","description":"365.44: Glaucoma associated with systemic syndromes"},
  {"code":"365.51","description":"365.51: Phacolytic glaucoma"},
  {"code":"365.52","description":"365.52: Pseudoexfoliation glaucoma"},
  {"code":"365.59","description":"365.59: Glaucoma associated with other lens disorders"},
  {"code":"365.60","description":"365.60: Glaucoma associated with unspecified ocular disorder"},
  {"code":"365.61","description":"365.61: Glaucoma associated with pupillary block"},
  {"code":"365.62","description":"365.62: Glaucoma associated with ocular inflammations"},
  {"code":"365.63","description":"365.63: Glaucoma associated with vascular disorders"},
  {"code":"365.64","description":"365.64: Glaucoma associated with tumors or cysts"},
  {"code":"365.65","description":"365.65: Glaucoma associated with ocular trauma"},
  {"code":"365.70","description":"365.70: Glaucoma stage, unspecified"},
  {"code":"365.71","description":"365.71: Mild stage glaucoma"},
  {"code":"365.72","description":"365.72: Moderate stage glaucoma"},
  {"code":"365.73","description":"365.73: Severe stage glaucoma"},
  {"code":"365.74","description":"365.74: Indeterminate stage glaucoma"},
  {"code":"365.81","description":"365.81: Hypersecretion glaucoma"},
  {"code":"365.82","description":"365.82: Glaucoma with increased episcleral venous pressure"},
  {"code":"365.83","description":"365.83: Aqueous misdirection"},
  {"code":"365.89","description":"365.89: Other specified glaucoma"},
  {"code":"365.9","description":"365.9: Unspecified glaucoma"},
  {"code":"366.00","description":"366.00: Nonsenile cataract, unspecified"},
  {"code":"366.01","description":"366.01: Anterior subcapsular polar cataract"},
  {"code":"366.02","description":"366.02: Posterior subcapsular polar cataract"},
  {"code":"366.03","description":"366.03: Cortical, lamellar, or zonular cataract"},
  {"code":"366.04","description":"366.04: Nuclear cataract"},
  {"code":"366.09","description":"366.09: Other and combined forms of nonsenile cataract"},
  {"code":"366.10","description":"366.10: Senile cataract, unspecified"},
  {"code":"366.11","description":"366.11: Pseudoexfoliation of lens capsule"},
  {"code":"366.12","description":"366.12: Incipient senile cataract"},
  {"code":"366.13","description":"366.13: Anterior subcapsular polar senile cataract"},
  {"code":"366.14","description":"366.14: Posterior subcapsular polar senile cataract"},
  {"code":"366.15","description":"366.15: Cortical senile cataract"},
  {"code":"366.16","description":"366.16: Senile nuclear sclerosis"},
  {"code":"366.17","description":"366.17: Total or mature cataract"},
  {"code":"366.18","description":"366.18: Hypermature cataract"},
  {"code":"366.19","description":"366.19: Other and combined forms of senile cataract"},
  {"code":"366.20","description":"366.20: Traumatic cataract, unspecified"},
  {"code":"366.21","description":"366.21: Localized traumatic opacities"},
  {"code":"366.22","description":"366.22: Total traumatic cataract"},
  {"code":"366.23","description":"366.23: Partially resolved traumatic cataract"},
  {"code":"366.30","description":"366.30: Cataracta complicata, unspecified"},
  {"code":"366.31","description":"366.31: Glaucomatous flecks (subcapsular)"},
  {"code":"366.32","description":"366.32: Cataract in inflammatory ocular disorders"},
  {"code":"366.33","description":"366.33: Cataract with neovascularization"},
  {"code":"366.34","description":"366.34: Cataract in degenerative ocular disorders"},
  {"code":"366.41","description":"366.41: Diabetic cataract"},
  {"code":"366.42","description":"366.42: Tetanic cataract"},
  {"code":"366.43","description":"366.43: Myotonic cataract"},
  {"code":"366.44","description":"366.44: Cataract associated with other syndromes"},
  {"code":"366.45","description":"366.45: Toxic cataract"},
  {"code":"366.46","description":"366.46: Cataract associated with radiation and other physical influences"},
  {"code":"366.50","description":"366.50: After-cataract, unspecified"},
  {"code":"366.51","description":"366.51: Soemmering\'s ring"},
  {"code":"366.52","description":"366.52: Other after-cataract, not obscuring vision"},
  {"code":"366.53","description":"366.53: After-cataract, obscuring vision"},
  {"code":"366.8","description":"366.8: Other cataract"},
  {"code":"366.9","description":"366.9: Unspecified cataract"},
  {"code":"367.0","description":"367.0: Hypermetropia"},
  {"code":"367.1","description":"367.1: Myopia"},
  {"code":"367.20","description":"367.20: Astigmatism, unspecified"},
  {"code":"367.21","description":"367.21: Regular astigmatism"},
  {"code":"367.22","description":"367.22: Irregular astigmatism"},
  {"code":"367.31","description":"367.31: Anisometropia"},
  {"code":"367.32","description":"367.32: Aniseikonia"},
  {"code":"367.4","description":"367.4: Presbyopia"},
  {"code":"367.51","description":"367.51: Paresis of accommodation"},
  {"code":"367.52","description":"367.52: Total or complete internal ophthalmoplegia"},
  {"code":"367.53","description":"367.53: Spasm of accommodation"},
  {"code":"367.81","description":"367.81: Transient refractive change"},
  {"code":"367.89","description":"367.89: Other disorders of refraction and accommodation"},
  {"code":"367.9","description":"367.9: Unspecified disorder of refraction and accommodation"},
  {"code":"368.00","description":"368.00: Amblyopia, unspecified"},
  {"code":"368.01","description":"368.01: Strabismic amblyopia"},
  {"code":"368.02","description":"368.02: Deprivation amblyopia"},
  {"code":"368.03","description":"368.03: Refractive amblyopia"},
  {"code":"368.10","description":"368.10: Subjective visual disturbance, unspecified"},
  {"code":"368.11","description":"368.11: Sudden visual loss"},
  {"code":"368.12","description":"368.12: Transient visual loss"},
  {"code":"368.13","description":"368.13: Visual discomfort"},
  {"code":"368.14","description":"368.14: Visual distortions of shape and size"},
  {"code":"368.15","description":"368.15: Other visual distortions and entoptic phenomena"},
  {"code":"368.16","description":"368.16: Psychophysical visual disturbances"},
  {"code":"368.2","description":"368.2: Diplopia"},
  {"code":"368.30","description":"368.30: Binocular vision disorder, unspecified"},
  {"code":"368.31","description":"368.31: Suppression of binocular vision"},
  {"code":"368.32","description":"368.32: Simultaneous visual perception without fusion"},
  {"code":"368.33","description":"368.33: Fusion with defective stereopsis"},
  {"code":"368.34","description":"368.34: Abnormal retinal correspondence"},
  {"code":"368.40","description":"368.40: Visual field defect, unspecified"},
  {"code":"368.41","description":"368.41: Scotoma involving central area"},
  {"code":"368.42","description":"368.42: Scotoma of blind spot area"},
  {"code":"368.43","description":"368.43: Sector or arcuate visual field defects"},
  {"code":"368.44","description":"368.44: Other localized visual field defect"},
  {"code":"368.45","description":"368.45: Generalized visual field contraction or constriction"},
  {"code":"368.46","description":"368.46: Homonymous bilateral field defects"},
  {"code":"368.47","description":"368.47: Heteronymous bilateral field defects"},
  {"code":"368.51","description":"368.51: Protan defect"},
  {"code":"368.52","description":"368.52: Deutan defect"},
  {"code":"368.53","description":"368.53: Tritan defect"},
  {"code":"368.54","description":"368.54: Achromatopsia"},
  {"code":"368.55","description":"368.55: Acquired color vision deficiencies"},
  {"code":"368.59","description":"368.59: Other color vision deficiencies"},
  {"code":"368.60","description":"368.60: Night blindness, unspecified"},
  {"code":"368.61","description":"368.61: Congenital night blindness"},
  {"code":"368.62","description":"368.62: Acquired night blindness"},
  {"code":"368.63","description":"368.63: Abnormal dark adaptation curve"},
  {"code":"368.69","description":"368.69: Other night blindness"},
  {"code":"368.8","description":"368.8: Other specified visual disturbances"},
  {"code":"368.9","description":"368.9: Unspecified visual disturbance"},
  {"code":"369.00","description":"369.00: Profound impairment, both eyes, impairment level not further specified"},
  {"code":"369.01","description":"369.01: Better eye: total vision impairment; lesser eye: total vision impairment"},
  {"code":"369.02","description":"369.02: Better eye: near-total vision impairment; lesser eye: not further specified"},
  {"code":"369.03","description":"369.03: Better eye: near-total vision impairment; lesser eye: total vision impairment"},
  {"code":"369.04","description":"369.04: Better eye: near-total vision impairment; lesser eye: near-total vision impairment"},
  {"code":"369.05","description":"369.05: Better eye: profound vision impairment; lesser eye: not further specified"},
  {"code":"369.06","description":"369.06: Better eye: profound vision impairment; lesser eye: total vision impairment"},
  {"code":"369.07","description":"369.07: Better eye: profound vision impairment; lesser eye: near-total vision impairment"},
  {"code":"369.08","description":"369.08: Better eye: profound vision impairment; lesser eye: profound vision impairment"},
  {"code":"369.10","description":"369.10: Moderate or severe impairment, better eye, impairment level not further specified"},
  {"code":"369.11","description":"369.11: Better eye: severe vision impairment; lesser eye: blind, not further specified"},
  {"code":"369.12","description":"369.12: Better eye: severe vision impairment; lesser eye: total vision impairment"},
  {"code":"369.13","description":"369.13: Better eye: severe vision impairment; lesser eye: near-total vision impairment"},
  {"code":"369.14","description":"369.14: Better eye: severe vision impairment; lesser eye: profound vision impairment"},
  {"code":"369.15","description":"369.15: Better eye: moderate vision impairment; lesser eye: blind, not further specified"},
  {"code":"369.16","description":"369.16: Better eye: moderate vision impairment; lesser eye: total vision impairment"},
  {"code":"369.17","description":"369.17: Better eye: moderate vision impairment; lesser eye: near-total vision impairment"},
  {"code":"369.18","description":"369.18: Better eye: moderate vision impairment; lesser eye: profound vision impairment"},
  {"code":"369.20","description":"369.20: Moderate or severe impairment, both eyes, impairment level not further specified"},
  {"code":"369.21","description":"369.21: Better eye: severe vision impairment; lesser eye; impairment not further specified"},
  {"code":"369.22","description":"369.22: Better eye: severe vision impairment; lesser eye: severe vision impairment"},
  {"code":"369.23","description":"369.23: Better eye: moderate vision impairment; lesser eye: impairment not further specified"},
  {"code":"369.24","description":"369.24: Better eye: moderate vision impairment; lesser eye: severe vision impairment"},
  {"code":"369.25","description":"369.25: Better eye: moderate vision impairment; lesser eye: moderate vision impairment"},
  {"code":"369.3","description":"369.3: Unqualified visual loss, both eyes"},
  {"code":"369.4","description":"369.4: Legal blindness, as defined in U.S.A."},
  {"code":"369.60","description":"369.60: Profound impairment, one eye, impairment level not further specified"},
  {"code":"369.61","description":"369.61: One eye: total vision impairment; other eye: not specified"},
  {"code":"369.62","description":"369.62: One eye: total vision impairment; other eye: near-normal vision"},
  {"code":"369.63","description":"369.63: One eye: total vision impairment; other eye: normal vision"},
  {"code":"369.64","description":"369.64: One eye: near-total vision impairment; other eye: vision not specified"},
  {"code":"369.65","description":"369.65: One eye: near-total vision impairment; other eye: near-normal vision"},
  {"code":"369.66","description":"369.66: One eye: near-total vision impairment; other eye: normal vision"},
  {"code":"369.67","description":"369.67: One eye: profound vision impairment; other eye: vision not specified"},
  {"code":"369.68","description":"369.68: One eye: profound vision impairment; other eye: near-normal vision"},
  {"code":"369.69","description":"369.69: One eye: profound vision impairment; other eye: normal vision"},
  {"code":"369.70","description":"369.70: Moderate or severe impairment, one eye, impairment level not further specified"},
  {"code":"369.71","description":"369.71: One eye: severe vision impairment; other eye: vision not specified"},
  {"code":"369.72","description":"369.72: One eye: severe vision impairment; other eye: near-normal vision"},
  {"code":"369.73","description":"369.73: One eye: severe vision impairment; other eye: normal vision"},
  {"code":"369.74","description":"369.74: One eye: moderate vision impairment; other eye: vision not specified"},
  {"code":"369.75","description":"369.75: One eye: moderate vision impairment; other eye: near-normal vision"},
  {"code":"369.76","description":"369.76: One eye: moderate vision impairment; other eye: normal vision"},
  {"code":"369.8","description":"369.8: Unqualified visual loss, one eye"},
  {"code":"369.9","description":"369.9: Unspecified visual loss"},
  {"code":"370.00","description":"370.00: Corneal ulcer, unspecified"},
  {"code":"370.01","description":"370.01: Marginal corneal ulcer"},
  {"code":"370.02","description":"370.02: Ring corneal ulcer"},
  {"code":"370.03","description":"370.03: Central corneal ulcer"},
  {"code":"370.04","description":"370.04: Hypopyon ulcer"},
  {"code":"370.05","description":"370.05: Mycotic corneal ulcer"},
  {"code":"370.06","description":"370.06: Perforated corneal ulcer"},
  {"code":"370.07","description":"370.07: Mooren\'s ulcer"},
  {"code":"370.20","description":"370.20: Superficial keratitis, unspecified"},
  {"code":"370.21","description":"370.21: Punctate keratitis"},
  {"code":"370.22","description":"370.22: Macular keratitis"},
  {"code":"370.23","description":"370.23: Filamentary keratitis"},
  {"code":"370.24","description":"370.24: Photokeratitis"},
  {"code":"370.31","description":"370.31: Phlyctenular keratoconjunctivitis"},
  {"code":"370.32","description":"370.32: Limbar and corneal involvement in vernal conjunctivitis"},
  {"code":"370.33","description":"370.33: Keratoconjunctivitis sicca, not specified as Sjogren\'s"},
  {"code":"370.34","description":"370.34: Exposure keratoconjunctivitis"},
  {"code":"370.35","description":"370.35: Neurotrophic keratoconjunctivitis"},
  {"code":"370.40","description":"370.40: Keratoconjunctivitis, unspecified"},
  {"code":"370.44","description":"370.44: Keratitis or keratoconjunctivitis in exanthema"},
  {"code":"370.49","description":"370.49: Other keratoconjunctivitis"},
  {"code":"370.50","description":"370.50: Interstitial keratitis, unspecified"},
  {"code":"370.52","description":"370.52: Diffuse interstitial keratitis"},
  {"code":"370.54","description":"370.54: Sclerosing keratitis"},
  {"code":"370.55","description":"370.55: Corneal abscess"},
  {"code":"370.59","description":"370.59: Other interstitial and deep keratitis"},
  {"code":"370.60","description":"370.60: Corneal neovascularization, unspecified"},
  {"code":"370.61","description":"370.61: Localized vascularization of cornea"},
  {"code":"370.62","description":"370.62: Pannus (corneal)"},
  {"code":"370.63","description":"370.63: Deep vascularization of cornea"},
  {"code":"370.64","description":"370.64: Ghost vessels (corneal)"},
  {"code":"370.8","description":"370.8: Other forms of keratitis"},
  {"code":"370.9","description":"370.9: Unspecified keratitis"},
  {"code":"371.00","description":"371.00: Corneal opacity, unspecified"},
  {"code":"371.01","description":"371.01: Minor opacity of cornea"},
  {"code":"371.02","description":"371.02: Peripheral opacity of cornea"},
  {"code":"371.03","description":"371.03: Central opacity of cornea"},
  {"code":"371.04","description":"371.04: Adherent leucoma"},
  {"code":"371.05","description":"371.05: Phthisical cornea"},
  {"code":"371.10","description":"371.10: Corneal deposit, unspecified"},
  {"code":"371.11","description":"371.11: Anterior corneal pigmentations"},
  {"code":"371.12","description":"371.12: Stromal corneal pigmentations"},
  {"code":"371.13","description":"371.13: Posterior corneal pigmentations"},
  {"code":"371.14","description":"371.14: Kayser-Fleischer ring"},
  {"code":"371.15","description":"371.15: Other corneal deposits associated with metabolic disorders"},
  {"code":"371.16","description":"371.16: Argentous corneal deposits"},
  {"code":"371.20","description":"371.20: Corneal edema, unspecified"},
  {"code":"371.21","description":"371.21: Idiopathic corneal edema"},
  {"code":"371.22","description":"371.22: Secondary corneal edema"},
  {"code":"371.23","description":"371.23: Bullous keratopathy"},
  {"code":"371.24","description":"371.24: Corneal edema due to wearing of contact lenses"},
  {"code":"371.30","description":"371.30: Corneal membrane change, unspecified"},
  {"code":"371.31","description":"371.31: Folds and rupture of bowman\'s membrane"},
  {"code":"371.32","description":"371.32: Folds in descemet\'s membrane"},
  {"code":"371.33","description":"371.33: Rupture in descemet\'s membrane"},
  {"code":"371.40","description":"371.40: Corneal degeneration, unspecified"},
  {"code":"371.41","description":"371.41: Senile corneal changes"},
  {"code":"371.42","description":"371.42: Recurrent erosion of cornea"},
  {"code":"371.43","description":"371.43: Band-shaped keratopathy"},
  {"code":"371.44","description":"371.44: Other calcerous degenerations of cornea"},
  {"code":"371.45","description":"371.45: Keratomalacia NOS"},
  {"code":"371.46","description":"371.46: Nodular degeneration of cornea"},
  {"code":"371.48","description":"371.48: Peripheral degenerations of cornea"},
  {"code":"371.49","description":"371.49: Other corneal degenerations"},
  {"code":"371.50","description":"371.50: Hereditary corneal dystrophy, unspecified"},
  {"code":"371.51","description":"371.51: Juvenile epithelial corneal dystrophy"},
  {"code":"371.52","description":"371.52: Other anterior corneal dystrophies"},
  {"code":"371.53","description":"371.53: Granular corneal dystrophy"},
  {"code":"371.54","description":"371.54: Lattice corneal dystrophy"},
  {"code":"371.55","description":"371.55: Macular corneal dystrophy"},
  {"code":"371.56","description":"371.56: Other stromal corneal dystrophies"},
  {"code":"371.57","description":"371.57: Endothelial corneal dystrophy"},
  {"code":"371.58","description":"371.58: Other posterior corneal dystrophies"},
  {"code":"371.60","description":"371.60: Keratoconus, unspecified"},
  {"code":"371.61","description":"371.61: Keratoconus, stable condition"},
  {"code":"371.62","description":"371.62: Keratoconus, acute hydrops"},
  {"code":"371.70","description":"371.70: Corneal deformity, unspecified"},
  {"code":"371.71","description":"371.71: Corneal ectasia"},
  {"code":"371.72","description":"371.72: Descemetocele"},
  {"code":"371.73","description":"371.73: Corneal staphyloma"},
  {"code":"371.81","description":"371.81: Corneal anesthesia and hypoesthesia"},
  {"code":"371.82","description":"371.82: Corneal disorder due to contact lens"},
  {"code":"371.89","description":"371.89: Other corneal disorders"},
  {"code":"371.9","description":"371.9: Unspecified corneal disorder"},
  {"code":"372.00","description":"372.00: Acute conjunctivitis, unspecified"},
  {"code":"372.01","description":"372.01: Serous conjunctivitis, except viral"},
  {"code":"372.02","description":"372.02: Acute follicular conjunctivitis"},
  {"code":"372.03","description":"372.03: Other mucopurulent conjunctivitis"},
  {"code":"372.04","description":"372.04: Pseudomembranous conjunctivitis"},
  {"code":"372.05","description":"372.05: Acute atopic conjunctivitis"},
  {"code":"372.06","description":"372.06: Acute chemical conjunctivitis"},
  {"code":"372.10","description":"372.10: Chronic conjunctivitis, unspecified"},
  {"code":"372.11","description":"372.11: Simple chronic conjunctivitis"},
  {"code":"372.12","description":"372.12: Chronic follicular conjunctivitis"},
  {"code":"372.13","description":"372.13: Vernal conjunctivitis"},
  {"code":"372.14","description":"372.14: Other chronic allergic conjunctivitis"},
  {"code":"372.15","description":"372.15: Parasitic conjunctivitis"},
  {"code":"372.20","description":"372.20: Blepharoconjunctivitis, unspecified"},
  {"code":"372.21","description":"372.21: Angular blepharoconjunctivitis"},
  {"code":"372.22","description":"372.22: Contact blepharoconjunctivitis"},
  {"code":"372.30","description":"372.30: Conjunctivitis, unspecified"},
  {"code":"372.31","description":"372.31: Rosacea conjunctivitis"},
  {"code":"372.33","description":"372.33: Conjunctivitis in mucocutaneous disease"},
  {"code":"372.34","description":"372.34: Pingueculitis"},
  {"code":"372.39","description":"372.39: Other conjunctivitis"},
  {"code":"372.40","description":"372.40: Pterygium, unspecified"},
  {"code":"372.41","description":"372.41: Peripheral pterygium, stationary"},
  {"code":"372.42","description":"372.42: Peripheral pterygium, progressive"},
  {"code":"372.43","description":"372.43: Central pterygium"},
  {"code":"372.44","description":"372.44: Double pterygium"},
  {"code":"372.45","description":"372.45: Recurrent pterygium"},
  {"code":"372.50","description":"372.50: Conjunctival degeneration, unspecified"},
  {"code":"372.51","description":"372.51: Pinguecula"},
  {"code":"372.52","description":"372.52: Pseudopterygium"},
  {"code":"372.53","description":"372.53: Conjunctival xerosis"},
  {"code":"372.54","description":"372.54: Conjunctival concretions"},
  {"code":"372.55","description":"372.55: Conjunctival pigmentations"},
  {"code":"372.56","description":"372.56: Conjunctival deposits"},
  {"code":"372.61","description":"372.61: Granuloma of conjunctiva"},
  {"code":"372.62","description":"372.62: Localized adhesions and strands of conjunctiva"},
  {"code":"372.63","description":"372.63: Symblepharon"},
  {"code":"372.64","description":"372.64: Scarring of conjunctiva"},
  {"code":"372.71","description":"372.71: Hyperemia of conjunctiva"},
  {"code":"372.72","description":"372.72: Conjunctival hemorrhage"},
  {"code":"372.73","description":"372.73: Conjunctival edema"},
  {"code":"372.74","description":"372.74: Vascular abnormalities of conjunctiva"},
  {"code":"372.75","description":"372.75: Conjunctival cysts"},
  {"code":"372.81","description":"372.81: Conjunctivochalasis"},
  {"code":"372.89","description":"372.89: Other disorders of conjunctiva"},
  {"code":"372.9","description":"372.9: Unspecified disorder of conjunctiva"},
  {"code":"373.00","description":"373.00: Blepharitis, unspecified"},
  {"code":"373.01","description":"373.01: Ulcerative blepharitis"},
  {"code":"373.02","description":"373.02: Squamous blepharitis"},
  {"code":"373.11","description":"373.11: Hordeolum externum"},
  {"code":"373.12","description":"373.12: Hordeolum internum"},
  {"code":"373.13","description":"373.13: Abscess of eyelid"},
  {"code":"373.2","description":"373.2: Chalazion"},
  {"code":"373.31","description":"373.31: Eczematous dermatitis of eyelid"},
  {"code":"373.32","description":"373.32: Contact and allergic dermatitis of eyelid"},
  {"code":"373.33","description":"373.33: Xeroderma of eyelid"},
  {"code":"373.34","description":"373.34: Discoid lupus erythematosus of eyelid"},
  {"code":"373.4","description":"373.4: Infective dermatitis of eyelid of types resulting in deformity"},
  {"code":"373.5","description":"373.5: Other infective dermatitis of eyelid"},
  {"code":"373.6","description":"373.6: Parasitic infestation of eyelid"},
  {"code":"373.8","description":"373.8: Other inflammations of eyelids"},
  {"code":"373.9","description":"373.9: Unspecified inflammation of eyelid"},
  {"code":"374.00","description":"374.00: Entropion, unspecified"},
  {"code":"374.01","description":"374.01: Senile entropion"},
  {"code":"374.02","description":"374.02: Mechanical entropion"},
  {"code":"374.03","description":"374.03: Spastic entropion"},
  {"code":"374.04","description":"374.04: Cicatricial entropion"},
  {"code":"374.05","description":"374.05: Trichiasis of eyelid without entropion"},
  {"code":"374.10","description":"374.10: Ectropion, unspecified"},
  {"code":"374.11","description":"374.11: Senile ectropion"},
  {"code":"374.12","description":"374.12: Mechanical ectropion"},
  {"code":"374.13","description":"374.13: Spastic ectropion"},
  {"code":"374.14","description":"374.14: Cicatricial ectropion"},
  {"code":"374.20","description":"374.20: Lagophthalmos, unspecified"},
  {"code":"374.21","description":"374.21: Paralytic lagophthalmos"},
  {"code":"374.22","description":"374.22: Mechanical lagophthalmos"},
  {"code":"374.23","description":"374.23: Cicatricial lagophthalmos"},
  {"code":"374.30","description":"374.30: Ptosis of eyelid, unspecified"},
  {"code":"374.31","description":"374.31: Paralytic ptosis"},
  {"code":"374.32","description":"374.32: Myogenic ptosis"},
  {"code":"374.33","description":"374.33: Mechanical ptosis"},
  {"code":"374.34","description":"374.34: Blepharochalasis"},
  {"code":"374.41","description":"374.41: Lid retraction or lag"},
  {"code":"374.43","description":"374.43: Abnormal innervation syndrome of eyelid"},
  {"code":"374.44","description":"374.44: Sensory disorders of eyelid"},
  {"code":"374.45","description":"374.45: Other sensorimotor disorders of eyelid"},
  {"code":"374.46","description":"374.46: Blepharophimosis"},
  {"code":"374.50","description":"374.50: Degenerative disorder of eyelid, unspecified"},
  {"code":"374.51","description":"374.51: Xanthelasma of eyelid"},
  {"code":"374.52","description":"374.52: Hyperpigmentation of eyelid"},
  {"code":"374.53","description":"374.53: Hypopigmentation of eyelid"},
  {"code":"374.54","description":"374.54: Hypertrichosis of eyelid"},
  {"code":"374.55","description":"374.55: Hypotrichosis of eyelid"},
  {"code":"374.56","description":"374.56: Other degenerative disorders of skin affecting eyelid"},
  {"code":"374.81","description":"374.81: Hemorrhage of eyelid"},
  {"code":"374.82","description":"374.82: Edema of eyelid"},
  {"code":"374.83","description":"374.83: Elephantiasis of eyelid"},
  {"code":"374.84","description":"374.84: Cysts of eyelids"},
  {"code":"374.85","description":"374.85: Vascular anomalies of eyelid"},
  {"code":"374.86","description":"374.86: Retained foreign body of eyelid"},
  {"code":"374.87","description":"374.87: Dermatochalasis"},
  {"code":"374.89","description":"374.89: Other disorders of eyelid"},
  {"code":"374.9","description":"374.9: Unspecified disorder of eyelid"},
  {"code":"375.00","description":"375.00: Dacryoadenitis, unspecified"},
  {"code":"375.01","description":"375.01: Acute dacryoadenitis"},
  {"code":"375.02","description":"375.02: Chronic dacryoadenitis"},
  {"code":"375.03","description":"375.03: Chronic enlargement of lacrimal gland"},
  {"code":"375.11","description":"375.11: Dacryops"},
  {"code":"375.12","description":"375.12: Other lacrimal cysts and cystic degeneration"},
  {"code":"375.13","description":"375.13: Primary lacrimal atrophy"},
  {"code":"375.14","description":"375.14: Secondary lacrimal atrophy"},
  {"code":"375.15","description":"375.15: Tear film insufficiency, unspecified"},
  {"code":"375.16","description":"375.16: Dislocation of lacrimal gland"},
  {"code":"375.20","description":"375.20: Epiphora, unspecified as to cause"},
  {"code":"375.21","description":"375.21: Epiphora due to excess lacrimation"},
  {"code":"375.22","description":"375.22: Epiphora due to insufficient drainage"},
  {"code":"375.30","description":"375.30: Dacryocystitis, unspecified"},
  {"code":"375.31","description":"375.31: Acute canaliculitis, lacrimal"},
  {"code":"375.32","description":"375.32: Acute dacryocystitis"},
  {"code":"375.33","description":"375.33: Phlegmonous dacryocystitis"},
  {"code":"375.41","description":"375.41: Chronic canaliculitis"},
  {"code":"375.42","description":"375.42: Chronic dacryocystitis"},
  {"code":"375.43","description":"375.43: Lacrimal mucocele"},
  {"code":"375.51","description":"375.51: Eversion of lacrimal punctum"},
  {"code":"375.52","description":"375.52: Stenosis of lacrimal punctum"},
  {"code":"375.53","description":"375.53: Stenosis of lacrimal canaliculi"},
  {"code":"375.54","description":"375.54: Stenosis of lacrimal sac"},
  {"code":"375.55","description":"375.55: Obstruction of nasolacrimal duct, neonatal"},
  {"code":"375.56","description":"375.56: Stenosis of nasolacrimal duct, acquired"},
  {"code":"375.57","description":"375.57: Dacryolith"},
  {"code":"375.61","description":"375.61: Lacrimal fistula"},
  {"code":"375.69","description":"375.69: Other changes of lacrimal passages"},
  {"code":"375.81","description":"375.81: Granuloma of lacrimal passages"},
  {"code":"375.89","description":"375.89: Other disorders of lacrimal system"},
  {"code":"375.9","description":"375.9: Unspecified disorder of lacrimal system"},
  {"code":"376.00","description":"376.00: Acute inflammation of orbit, unspecified"},
  {"code":"376.01","description":"376.01: Orbital cellulitis"},
  {"code":"376.02","description":"376.02: Orbital periostitis"},
  {"code":"376.03","description":"376.03: Orbital osteomyelitis"},
  {"code":"376.04","description":"376.04: Orbital tenonitis"},
  {"code":"376.10","description":"376.10: Chronic inflammation of orbit, unspecified"},
  {"code":"376.11","description":"376.11: Orbital granuloma"},
  {"code":"376.12","description":"376.12: Orbital myositis"},
  {"code":"376.13","description":"376.13: Parasitic infestation of orbit"},
  {"code":"376.21","description":"376.21: Thyrotoxic exophthalmos"},
  {"code":"376.22","description":"376.22: Exophthalmic ophthalmoplegia"},
  {"code":"376.30","description":"376.30: Exophthalmos, unspecified"},
  {"code":"376.31","description":"376.31: Constant exophthalmos"},
  {"code":"376.32","description":"376.32: Orbital hemorrhage"},
  {"code":"376.33","description":"376.33: Orbital edema or congestion"},
  {"code":"376.34","description":"376.34: Intermittent exophthalmos"},
  {"code":"376.35","description":"376.35: Pulsating exophthalmos"},
  {"code":"376.36","description":"376.36: Lateral displacement of globe"},
  {"code":"376.40","description":"376.40: Deformity of orbit, unspecified"},
  {"code":"376.41","description":"376.41: Hypertelorism of orbit"},
  {"code":"376.42","description":"376.42: Exostosis of orbit"},
  {"code":"376.43","description":"376.43: Local deformities of orbit due to bone disease"},
  {"code":"376.44","description":"376.44: Orbital deformities associated with craniofacial deformities"},
  {"code":"376.45","description":"376.45: Atrophy of orbit"},
  {"code":"376.46","description":"376.46: Enlargement of orbit"},
  {"code":"376.47","description":"376.47: Deformity of orbit due to trauma or surgery"},
  {"code":"376.50","description":"376.50: Enophthalmos, unspecified as to cause"},
  {"code":"376.51","description":"376.51: Enophthalmos due to atrophy of orbital tissue"},
  {"code":"376.52","description":"376.52: Enophthalmos due to trauma or surgery"},
  {"code":"376.6","description":"376.6: Retained (old) foreign body following penetrating wound of orbit"},
  {"code":"376.81","description":"376.81: Orbital cysts"},
  {"code":"376.82","description":"376.82: Myopathy of extraocular muscles"},
  {"code":"376.89","description":"376.89: Other orbital disorders"},
  {"code":"376.9","description":"376.9: Unspecified disorder of orbit"},
  {"code":"377.00","description":"377.00: Papilledema, unspecified"},
  {"code":"377.01","description":"377.01: Papilledema associated with increased intracranial pressure"},
  {"code":"377.02","description":"377.02: Papilledema associated with decreased ocular pressure"},
  {"code":"377.03","description":"377.03: Papilledema associated with retinal disorder"},
  {"code":"377.04","description":"377.04: Foster-Kennedy syndrome"},
  {"code":"377.10","description":"377.10: Optic atrophy, unspecified"},
  {"code":"377.11","description":"377.11: Primary optic atrophy"},
  {"code":"377.12","description":"377.12: Postinflammatory optic atrophy"},
  {"code":"377.13","description":"377.13: Optic atrophy associated with retinal dystrophies"},
  {"code":"377.14","description":"377.14: Glaucomatous atrophy [cupping] of optic disc"},
  {"code":"377.15","description":"377.15: Partial optic atrophy"},
  {"code":"377.16","description":"377.16: Hereditary optic atrophy"},
  {"code":"377.21","description":"377.21: Drusen of optic disc"},
  {"code":"377.22","description":"377.22: Crater-like holes of optic disc"},
  {"code":"377.23","description":"377.23: Coloboma of optic disc"},
  {"code":"377.24","description":"377.24: Pseudopapilledema"},
  {"code":"377.30","description":"377.30: Optic neuritis, unspecified"},
  {"code":"377.31","description":"377.31: Optic papillitis"},
  {"code":"377.32","description":"377.32: Retrobulbar neuritis (acute)"},
  {"code":"377.33","description":"377.33: Nutritional optic neuropathy"},
  {"code":"377.34","description":"377.34: Toxic optic neuropathy"},
  {"code":"377.39","description":"377.39: Other optic neuritis"},
  {"code":"377.41","description":"377.41: Ischemic optic neuropathy"},
  {"code":"377.42","description":"377.42: Hemorrhage in optic nerve sheaths"},
  {"code":"377.43","description":"377.43: Optic nerve hypoplasia"},
  {"code":"377.49","description":"377.49: Other disorders of optic nerve"},
  {"code":"377.51","description":"377.51: Disorders of optic chiasm associated with pituitary neoplasms and disorders"},
  {"code":"377.52","description":"377.52: Disorders of optic chiasm associated with other neoplasms"},
  {"code":"377.53","description":"377.53: Disorders of optic chiasm associated with vascular disorders"},
  {"code":"377.54","description":"377.54: Disorders of optic chiasm associated with inflammatory disorders"},
  {"code":"377.61","description":"377.61: Disorders of other visual pathways associated with neoplasms"},
  {"code":"377.62","description":"377.62: Disorders of other visual pathways associated with vascular disorders"},
  {"code":"377.63","description":"377.63: Disorders of other visual pathways associated with inflammatory disorders"},
  {"code":"377.71","description":"377.71: Disorders of visual cortex associated with neoplasms"},
  {"code":"377.72","description":"377.72: Disorders of visual cortex associated with vascular disorders"},
  {"code":"377.73","description":"377.73: Disorders of visual cortex associated with inflammatory disorders"},
  {"code":"377.75","description":"377.75: Cortical blindness"},
  {"code":"377.9","description":"377.9: Unspecified disorder of optic nerve and visual pathways"},
  {"code":"378.00","description":"378.00: Esotropia, unspecified"},
  {"code":"378.01","description":"378.01: Monocular esotropia"},
  {"code":"378.02","description":"378.02: Monocular esotropia with A pattern"},
  {"code":"378.03","description":"378.03: Monocular esotropia with V pattern"},
  {"code":"378.04","description":"378.04: Monocular esotropia with other noncomitancies"},
  {"code":"378.05","description":"378.05: Alternating esotropia"},
  {"code":"378.06","description":"378.06: Alternating esotropia with A pattern"},
  {"code":"378.07","description":"378.07: Alternating esotropia with V pattern"},
  {"code":"378.08","description":"378.08: Alternating esotropia with other noncomitancies"},
  {"code":"378.10","description":"378.10: Exotropia, unspecified"},
  {"code":"378.11","description":"378.11: Monocular exotropia"},
  {"code":"378.12","description":"378.12: Monocular exotropia with A pattern"},
  {"code":"378.13","description":"378.13: Monocular exotropia with V pattern"},
  {"code":"378.14","description":"378.14: Monocular exotropia with other noncomitancies"},
  {"code":"378.15","description":"378.15: Alternating exotropia"},
  {"code":"378.16","description":"378.16: Alternating exotropia with A pattern"},
  {"code":"378.17","description":"378.17: Alternating exotropia with V pattern"},
  {"code":"378.18","description":"378.18: Alternating exotropia with other noncomitancies"},
  {"code":"378.20","description":"378.20: Intermittent heterotropia, unspecified"},
  {"code":"378.21","description":"378.21: Intermittent esotropia, monocular"},
  {"code":"378.22","description":"378.22: Intermittent esotropia, alternating"},
  {"code":"378.23","description":"378.23: Intermittent exotropia, monocular"},
  {"code":"378.24","description":"378.24: Intermittent exotropia, alternating"},
  {"code":"378.30","description":"378.30: Heterotropia, unspecified"},
  {"code":"378.31","description":"378.31: Hypertropia"},
  {"code":"378.32","description":"378.32: Hypotropia"},
  {"code":"378.33","description":"378.33: Cyclotropia"},
  {"code":"378.34","description":"378.34: Monofixation syndrome"},
  {"code":"378.35","description":"378.35: Accommodative component in esotropia"},
  {"code":"378.40","description":"378.40: Heterophoria, unspecified"},
  {"code":"378.41","description":"378.41: Esophoria"},
  {"code":"378.42","description":"378.42: Exophoria"},
  {"code":"378.43","description":"378.43: Vertical heterophoria"},
  {"code":"378.44","description":"378.44: Cyclophoria"},
  {"code":"378.45","description":"378.45: Alternating hyperphoria"},
  {"code":"378.50","description":"378.50: Paralytic strabismus, unspecified"},
  {"code":"378.51","description":"378.51: Third or oculomotor nerve palsy, partial"},
  {"code":"378.52","description":"378.52: Third or oculomotor nerve palsy, total"},
  {"code":"378.53","description":"378.53: Fourth or trochlear nerve palsy"},
  {"code":"378.54","description":"378.54: Sixth or abducens nerve palsy"},
  {"code":"378.55","description":"378.55: External ophthalmoplegia"},
  {"code":"378.56","description":"378.56: Total ophthalmoplegia"},
  {"code":"378.60","description":"378.60: Mechanical strabismus, unspecified"},
  {"code":"378.61","description":"378.61: Brown\'s (tendon) sheath syndrome"},
  {"code":"378.62","description":"378.62: Mechanical strabismus from other musculofascial disorders"},
  {"code":"378.63","description":"378.63: Limited duction associated with other conditions"},
  {"code":"378.71","description":"378.71: Duane\'s syndrome"},
  {"code":"378.72","description":"378.72: Progressive external ophthalmoplegia"},
  {"code":"378.73","description":"378.73: Strabismus in other neuromuscular disorders"},
  {"code":"378.81","description":"378.81: Palsy of conjugate gaze"},
  {"code":"378.82","description":"378.82: Spasm of conjugate gaze"},
  {"code":"378.83","description":"378.83: Convergence insufficiency or palsy"},
  {"code":"378.84","description":"378.84: Convergence excess or spasm"},
  {"code":"378.85","description":"378.85: Anomalies of divergence"},
  {"code":"378.86","description":"378.86: Internuclear ophthalmoplegia"},
  {"code":"378.87","description":"378.87: Other dissociated deviation of eye movements"},
  {"code":"378.9","description":"378.9: Unspecified disorder of eye movements"},
  {"code":"379.00","description":"379.00: Scleritis, unspecified"},
  {"code":"379.01","description":"379.01: Episcleritis periodica fugax"},
  {"code":"379.02","description":"379.02: Nodular episcleritis"},
  {"code":"379.03","description":"379.03: Anterior scleritis"},
  {"code":"379.04","description":"379.04: Scleromalacia perforans"},
  {"code":"379.05","description":"379.05: Scleritis with corneal involvement"},
  {"code":"379.06","description":"379.06: Brawny scleritis"},
  {"code":"379.07","description":"379.07: Posterior scleritis"},
  {"code":"379.09","description":"379.09: Other scleritis and episcleritis"},
  {"code":"379.11","description":"379.11: Scleral ectasia"},
  {"code":"379.12","description":"379.12: Staphyloma posticum"},
  {"code":"379.13","description":"379.13: Equatorial staphyloma"},
  {"code":"379.14","description":"379.14: Anterior staphyloma, localized"},
  {"code":"379.15","description":"379.15: Ring staphyloma"},
  {"code":"379.16","description":"379.16: Other degenerative disorders of sclera"},
  {"code":"379.19","description":"379.19: Other disorders of sclera"},
  {"code":"379.21","description":"379.21: Vitreous degeneration"},
  {"code":"379.22","description":"379.22: Crystalline deposits in vitreous"},
  {"code":"379.23","description":"379.23: Vitreous hemorrhage"},
  {"code":"379.24","description":"379.24: Other vitreous opacities"},
  {"code":"379.25","description":"379.25: Vitreous membranes and strands"},
  {"code":"379.26","description":"379.26: Vitreous prolapse"},
  {"code":"379.27","description":"379.27: Vitreomacular adhesion"},
  {"code":"379.29","description":"379.29: Other disorders of vitreous"},
  {"code":"379.31","description":"379.31: Aphakia"},
  {"code":"379.32","description":"379.32: Subluxation of lens"},
  {"code":"379.33","description":"379.33: Anterior dislocation of lens"},
  {"code":"379.34","description":"379.34: Posterior dislocation of lens"},
  {"code":"379.39","description":"379.39: Other disorders of lens"},
  {"code":"379.40","description":"379.40: Abnormal pupillary function, unspecified"},
  {"code":"379.41","description":"379.41: Anisocoria"},
  {"code":"379.42","description":"379.42: Miosis (persistent), not due to miotics"},
  {"code":"379.43","description":"379.43: Mydriasis (persistent), not due to mydriatics"},
  {"code":"379.45","description":"379.45: Argyll Robertson pupil, atypical"},
  {"code":"379.46","description":"379.46: Tonic pupillary reaction"},
  {"code":"379.49","description":"379.49: Other anomalies of pupillary function"},
  {"code":"379.50","description":"379.50: Nystagmus, unspecified"},
  {"code":"379.51","description":"379.51: Congenital nystagmus"},
  {"code":"379.52","description":"379.52: Latent nystagmus"},
  {"code":"379.53","description":"379.53: Visual deprivation nystagmus"},
  {"code":"379.54","description":"379.54: Nystagmus associated with disorders of the vestibular system"},
  {"code":"379.55","description":"379.55: Dissociated nystagmus"},
  {"code":"379.56","description":"379.56: Other forms of nystagmus"},
  {"code":"379.57","description":"379.57: Deficiencies of saccadic eye movements"},
  {"code":"379.58","description":"379.58: Deficiencies of smooth pursuit movements"},
  {"code":"379.59","description":"379.59: Other irregularities of eye movements"},
  {"code":"379.60","description":"379.60: Inflammation (infection) of postprocedural bleb, unspecified"},
  {"code":"379.61","description":"379.61: Inflammation (infection) of postprocedural bleb, stage 1"},
  {"code":"379.62","description":"379.62: Inflammation (infection) of postprocedural bleb, stage 2"},
  {"code":"379.63","description":"379.63: Inflammation (infection) of postprocedural bleb, stage 3"},
  {"code":"379.8","description":"379.8: Other specified disorders of eye and adnexa"},
  {"code":"379.90","description":"379.90: Disorder of eye, unspecified"},
  {"code":"379.91","description":"379.91: Pain in or around eye"},
  {"code":"379.92","description":"379.92: Swelling or mass of eye"},
  {"code":"379.93","description":"379.93: Redness or discharge of eye"},
  {"code":"379.99","description":"379.99: Other ill-defined disorders of eye"}
]
